import React, { useEffect, useState, useRef } from "react";
import "../../css_files/Customer/CustomerEnquiries.css";
import axiosInstance from "../../api";
import CustomerEnquiryDetail from "./CustomerEnquiryDetail";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

function CustomerEnquiries() {
  const [customerEnquiries, setCustomerEnquiries] = useState([]);
  const [customerEnquiryId, setCustomerEnquiryId] = useState(0);
  const [showenquiryDetail, setShowEnquiryDetail] = useState(false);
  const [refresh, setrefresh] = useState(false);

  useEffect(() => {
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/CustomerEnquiries`)
      .then((res) => {
        setCustomerEnquiries(res.data);
      })
      .catch(console.log);
  }, [refresh]);

  return (
    <>
      <section className="customer-enquiries">
        <h1>Customer Enquiries</h1>
        <section className="table">
          <section>
            <div>
              <aside style={{ gridTemplateColumns: `repeat(7, 1fr)` }}>
                <blockquote>Sr.No.</blockquote>
                <blockquote>Company/Organization Name</blockquote>
                <blockquote>Enquiry Type</blockquote>
                <blockquote>Enquiry Date</blockquote>
                <blockquote>Priority</blockquote>
                <blockquote style={{ gridColumn: "span 2" }}>
                  Actions
                </blockquote>
              </aside>
            </div>
            <div>
              {customerEnquiries.length > 0 ? (
                customerEnquiries.map((x, i) => (
                  <aside style={{ gridTemplateColumns: `repeat(7, 1fr)` }}>
                    <blockquote>{i + 1}</blockquote>
                    <blockquote>{x.companyName}</blockquote>
                    <blockquote>{x.enquiryType}</blockquote>
                    <blockquote>
                      {new Date(x.enquiryDate).toDateString()}
                    </blockquote>
                    <blockquote>{x.priority}</blockquote>
                    <blockquote
                      onClick={() => {
                        setCustomerEnquiryId(x.id);
                        setShowEnquiryDetail(true);
                      }}
                    >
                      <i className="fa-solid fa-eye"></i>
                    </blockquote>
                    <blockquote
                      onClick={() => {
                        Swal.fire({
                          icon: "error",
                          title: "Are You Sure?",
                          showConfirmButton: true,
                          showCancelButton: true,
                        }).then((res) => {
                          if (res.isConfirmed) {
                            axiosInstance
                              .delete(
                                `${process.env.REACT_APP_API_URL}/api/CustomerEnquiries/${x.id}`
                              )
                              .then((res) => {
                                toast.success(res.data, {
                                  position: "bottom-center",
                                  theme: "dark",
                                });
                                setrefresh(!refresh);
                              })
                              .catch((err) => {
                                toast.error("Failed to Delete", {
                                  position: "bottom-center",
                                  theme: "dark",
                                });
                              });
                          }
                        });
                      }}
                    >
                      <i className="fa-solid fa-trash"></i>
                    </blockquote>
                  </aside>
                ))
              ) : (
                <aside style={{ gridTemplateColumns: `repeat(7, 1fr)` }}>
                  <blockquote style={{ gridColumn: "span 7" }}>
                    <center>No Customer Enquiries Found</center>
                  </blockquote>
                </aside>
              )}
            </div>
          </section>
        </section>
      </section>
      {showenquiryDetail && (
        <CustomerEnquiryDetail
          setShowEnquiryDetail={setShowEnquiryDetail}
          customerEnquiryId={customerEnquiryId}
        />
      )}
    </>
  );
}

export default CustomerEnquiries;
